"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { CLASSIFICATIONS } from "@/entities/IProfile";
import type { ApiProfileClassification } from "@/generated/models/ApiProfileClassification";
export default function UserSettingsClassificationItem(t0) {
  const $ = _c(15);
  const {
    classification,
    selected,
    onClassification
  } = t0;
  const [isActive, setIsActive] = useState(classification === selected);
  let t1;
  let t2;
  if ($[0] !== classification || $[1] !== selected) {
    t1 = () => {
      setIsActive(classification === selected);
    };
    t2 = [selected, classification];
    $[0] = classification;
    $[1] = selected;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== classification || $[5] !== onClassification) {
    t3 = () => onClassification(classification);
    $[4] = classification;
    $[5] = onClassification;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = CLASSIFICATIONS[classification];
  let t5;
  if ($[7] !== t4.title) {
    t5 = <span className="tw-inline-block tw-text-sm tw-font-medium tw-text-white">{t4.title}</span>;
    $[7] = t4.title;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== isActive) {
    t6 = isActive && <svg className="tw-h-5 tw-w-5 tw-ml-2 tw-text-primary-300 tw-transition tw-duration-300 tw-ease-out" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[9] = isActive;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t3 || $[12] !== t5 || $[13] !== t6) {
    t7 = <li onClick={t3} className="tw-group tw-text-white tw-justify-between tw-w-full tw-flex tw-rounded-lg tw-relative tw-cursor-pointer tw-select-none tw-p-2 hover:tw-bg-iron-700 tw-transition tw-duration-300 tw-ease-out">{t5}{t6}</li>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}